import { SettingsManager } from "@viamap/viamap2-common"

export class viaKUCollector {

   static mtrkInfo(ejerlav: string, matrikelNr: string, enviroment?: string): Promise<mtrkInfoResponse | undefined> {
      const mtrkInfoToken = SettingsManager.getSystemSetting("mtrkInfoToken")
      let mtrkInfoUrl: string = SettingsManager.getSystemSetting("mtrkInfoUrl")
      const params = {
         ejerlav: ejerlav,
         matrikel: matrikelNr,
      }
      if (enviroment) {
         let splitted = mtrkInfoUrl.split("/")
         splitted[3] = enviroment
         mtrkInfoUrl = splitted.join("/")
      }

      return fetch(mtrkInfoUrl + "&" + new URLSearchParams(params), { headers: { "x-api-key": mtrkInfoToken, Accept: 'application/json' } }).then((a) => {
         if (a.ok) {
            return a.json()
         }
      })
   }

}

export class AsyncCache {
   private cache: Record<string, Promise<any>> = {};
   private funcCache: (...key: any[]) => Promise<any> = () => { return Promise.resolve(); };
   constructor(func: (...key: any[]) => Promise<any>) {
      this.funcCache = func;
   }

   async get<T extends any[]>(...key: T): Promise<any> {
      const cacheKey = JSON.stringify(key.join("|"));
      if (await this.cache[cacheKey]) {
         return this.cache[cacheKey];
      }
      const result = this.funcCache(...key);
      this.cache[cacheKey] = result;
      return result;
   }
}

type mtrkInfoResponse = {}